// extracted by mini-css-extract-plugin
module.exports = {"root":"AwsCurStreamEditor-module__root__1he7c","input-description":"AwsCurStreamEditor-module__input-description__CN-Gp"};